// extracted by mini-css-extract-plugin
export var closeButton = "ProductGallery-module--closeButton--75552";
export var gallery = "ProductGallery-module--gallery--4c36a";
export var image = "ProductGallery-module--image--35786";
export var productGallery = "ProductGallery-module--productGallery--0183f";
export var productGalleryModal = "ProductGallery-module--productGalleryModal--ed0f0";
export var singleImage = "ProductGallery-module--singleImage--1a6a6";
export var viewAllButton = "ProductGallery-module--viewAllButton--1b25a";